module.exports = __webpack_public_path__ + "8615ed1ede3db419e488eb9998977107.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/objekte/_HUM2428.jpg
// module id = 366
// module chunks = 0